import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/Duo/Duo.css';

export const prototypeName = 'DLwVpQRj0bCyKkRGqd2eSjOMMqbaGnSqljKjqRdGIk0VXKPKr3fR4r4bLgy4CZQg63';
export {styles};